import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import StorageIcon from '@mui/icons-material/Storage';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

import { PageContainer } from '../layout/PageContainer';

const PRINCIPLES = [
  {
    icon: StorageIcon,
    title: 'Real listings, not guesses',
    body: 'Every price we show comes from actual ads on the Bulgarian car market, tracked over time - not a single quote or a manufacturer\'s suggested price.',
  },
  {
    icon: SsidChartIcon,
    title: 'Trends, not snapshots',
    body: 'A single asking price tells you little. We track how the average price for a specific make, model, and generation moves over months, so you can tell a fair deal from a bad one.',
  },
  {
    icon: VerifiedOutlinedIcon,
    title: 'A research tool, not a dealership',
    body: 'AutoAdviser doesn\'t sell cars or take a cut of any sale. The only goal is to put real market data in your hands before you negotiate.',
  },
];

export function About() {
  return (
    <PageContainer>
      <Typography variant="h4" gutterBottom>
        About AutoAdviser
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4, maxWidth: 720 }}>
        AutoAdviser tracks how car prices actually move on the Bulgarian market, so you can walk into a purchase
        knowing what a fair price looks like - not just what one seller is asking.
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 3, mb: 5 }}>
        {PRINCIPLES.map((principle) => (
          <Card key={principle.title} sx={{ p: 3 }}>
            <Stack spacing={1.5}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'secondary.main',
                  color: 'secondary.contrastText',
                }}
              >
                <principle.icon />
              </Box>
              <Typography variant="h6">{principle.title}</Typography>
              <Typography color="text.secondary">{principle.body}</Typography>
            </Stack>
          </Card>
        ))}
      </Box>

      <Stack direction="row" spacing={1} alignItems="center">
        <ChatBubbleOutlineIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography variant="body2" color="text.secondary">
          Questions or found bad data?{' '}
          <a href="viber://chat/?number=%2B359883506455" style={{ color: 'inherit' }}>
            Chat with us on Viber
          </a>
        </Typography>
      </Stack>
    </PageContainer>
  );
}
